import { Component, Input, OnInit } from '@angular/core';
import { RoiService } from '@smartflip/ui-utils';
import { FieldConfig } from '@smartflip/data-models';
import { PropertyService } from '@smartflip/helper-utils';
import { FirebaseAnalyticsService } from '@smartflip/data-firebase';
import { getIonicIcon } from '@smartflip/util-formatters';
import { ComparablesService } from '@smartflip/service-comparables';
import { PropertyDetailsService } from './property-details.service';
import { tabSections } from './property-details.constants';
import { sortTabsByStatus } from './property-details.helper';

@Component({
  selector: 'app-calculation',
  templateUrl: './property-details.component.html',
  styleUrls: ['./property-details.component.scss'],
  standalone: false,
})
export class PropertyDetailsComponent implements OnInit {
  @Input() propertyId: string;
  profit: FieldConfig;
  public propertyIsSet$ = this.propertyDetailsService.propertyIsSet$;
  public compError: boolean;
  public routeLoaded: boolean;
  public tabSections;
  public showComps = false;
  public selectedSegment = 0;
  public getIonicIcon = getIonicIcon;
  public dataLoaded$ = this.roi.dataLoaded$;

  constructor(
    private propService: PropertyService,
    private compService: ComparablesService,
    private firebaseAnalyticsService: FirebaseAnalyticsService,
    public roi: RoiService,
    private propertyDetailsService: PropertyDetailsService,
  ) {}

  handleTabChange(event: CustomEvent) {
    const newTabIndex = event.detail.value;
    const tabName = this.tabSections[newTabIndex].label || 'General';

    this.selectedSegment = newTabIndex;
    this.showComps = tabName === 'Comps';
    this.checkProperty();
    this.firebaseAnalyticsService.logEvent({
      name: 'screen_view',
      params: {
        screen_name: tabName,
      },
    });
  }

  checkProperty() {
    const { address, zip } = this.roi.formGroups.gen.value;
    const idExists =
      this.propService.propertyId && this.propService.propertyId?.length > 0;
    const addressIsSet = address?.length > 0;
    const zipCodeExists = zip?.length > 0;
    const propertySetCheck = idExists && addressIsSet && zipCodeExists;

    this.propertyDetailsService.setProperty(propertySetCheck);
    this.compError = false; // reset this every time
    //TODO: compError should only be reset if address details are changed.
  }

  private async resetView() {
    this.compService.reset(); // clear any existing comps
    this.compError = false;
    await this.propService.setCurrentProperty(this.propertyId);
    const { solddate, purchasedate, address, city, state } =
      this.propService.currentProperty.gen;
    const status = solddate ? 'sold' : purchasedate ? 'active' : 'pending';

    // TODO: update to use with Ionic tabs
    this.tabSections = tabSections.sort(sortTabsByStatus(status));
    await this.init();

    this.propertyDetailsService.setDisplayAddress(
      `${address}, ${city}, ${state}`,
    );
  }

  async init() {
    await this.roi.init(this.propertyId); // reset the ROI service every time we reach this view
    this.routeLoaded = true;
    this.propertyDetailsService.setProperty(true);
  }

  ngOnInit() {
    this.resetView();
  }
}
